// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__Qr2hV","notes":"Notes_notes__EWDKW","note":"Notes_note__5EPi5","markdown":"Notes_markdown__3xncr"};